precision highp float;

attribute vec2 uv;
attribute vec3 position;
attribute vec3 normal;

uniform mat4 modelViewMatrix;
uniform mat4 modelMatrix;
uniform mat4 projectionMatrix;

uniform float uTime;
uniform float uScroll;

varying vec3 vPosition;

varying vec2 vUv;

void main() {
    float diff = sin(uTime + uScroll * 0.002) * 0.5 + 0.5;

    // gl_Position.x -= sin(gl_Position.y * 1.0) / 1.0;

    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    vPosition = (modelMatrix * vec4(position, 1.0)).xyz;
}